/**
 * Kwolly FAQ — Web Component
 * Handles accordion open/close with ARIA state management.
 * Follows Shopify Dawn's Web Component pattern.
 */

class KwollyFaqItem extends HTMLElement {
  connectedCallback() {
    this._init();
  }

  disconnectedCallback() {
    if (this._trigger && this._onClickBound) {
      this._trigger.removeEventListener('click', this._onClickBound);
    }
  }

  _init() {
    // Remove any previous listener before re-binding to prevent duplicates
    // when connectedCallback fires or when _init is called after section reload.
    if (this._trigger && this._onClickBound) {
      this._trigger.removeEventListener('click', this._onClickBound);
    }

    this._trigger = this.querySelector('.kwolly-faq__item-trigger');
    if (!this._trigger) return;

    this._onClickBound = this._onClick.bind(this);
    this._trigger.addEventListener('click', this._onClickBound);
  }

  _onClick() {
    const isOpen = this.classList.toggle('is-open');
    this._trigger.setAttribute('aria-expanded', String(isOpen));
  }

  open() {
    this.classList.add('is-open');
    if (this._trigger) this._trigger.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.classList.remove('is-open');
    if (this._trigger) this._trigger.setAttribute('aria-expanded', 'false');
  }
}

if (!customElements.get('kwolly-faq-item')) {
  customElements.define('kwolly-faq-item', KwollyFaqItem);
}

/**
 * Theme Editor events — re-initialize when the section is reloaded
 * and auto-open a block when it is selected in the editor.
 */
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('kwolly-faq-item').forEach((item) => {
    item._init();
  });
});

document.addEventListener('shopify:block:select', (event) => {
  const item = event.target.closest('kwolly-faq-item');
  if (item) item.open();
});

document.addEventListener('shopify:block:deselect', (event) => {
  const item = event.target.closest('kwolly-faq-item');
  if (item) item.close();
});
